export default "__VITE_ASSET__81d131d6__"